import React from 'react';
import { SparkleIcon } from './icons/SparkleIcon';
import { DownloadIcon } from './icons/DownloadIcon';
import { DeviceIcon } from './icons/DeviceIcon';
import { ClockIcon } from './icons/ClockIcon';
import { InfinityIcon } from './icons/InfinityIcon';
const benefits = ['Dominar Hydra Lips y BB Lips desde cero', 'Practicar de forma segura y profesional', 'Lograr labios hidratados, parejos y naturales', 'Ofrecer un servicio premium que pueden cobrar mejor', 'Diferenciarse en un mercado que no para de crecer'];
const features = [{
  icon: DownloadIcon,
  text: 'Acceso inmediato'
}, {
  icon: DeviceIcon,
  text: 'Desde cualquier dispositivo'
}, {
  icon: ClockIcon,
  text: 'A tu ritmo'
}, {
  icon: InfinityIcon,
  text: 'Acceso de por vida'
}];
export function Solution() {
  return <section className="py-12 px-4 bg-[#FDFBF7]" data-id="element-255">
      <div className="max-w-5xl mx-auto" data-id="element-256">
        <div className="text-center mb-10 space-y-3" data-id="element-257">
          <div className="inline-flex items-center gap-2 text-[#E5A5A0] mb-1" data-id="element-258">
            <SparkleIcon className="w-4 h-4" data-id="element-259" />
          </div>

          <h2 className="text-2xl md:text-3xl font-semibold text-[#3D3028]" data-id="element-260">
            La solución: el Método Hydra Gloss Lips™
          </h2>

          <p className="text-sm md:text-base text-[#3D3028]/70 max-w-2xl mx-auto" data-id="element-261">
            Un sistema probado que ya ayudó a miles de alumnas a:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-262">
          {benefits.map((benefit, index) => <div key={index} className="bg-white p-6 rounded-xl border border-[#D4C4B0]/20" data-id="element-263">
              <SparkleIcon className="w-5 h-5 text-[#E5A5A0] mb-3" data-id="element-264" />
              <p className="text-sm text-[#3D3028]/80 leading-snug" data-id="element-265">
                {benefit}
              </p>
            </div>)}
        </div>

        <div className="mb-12" data-id="element-266">
          <div className="text-center mb-6" data-id="element-267">
            <h3 className="text-xl md:text-2xl font-semibold text-[#3D3028] mb-2" data-id="element-268">
              Resultados Reales del Método
            </h3>
            <p className="text-sm text-[#3D3028]/70" data-id="element-269">
              Así se ven los labios después del tratamiento profesional
            </p>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-xl border border-[#D4C4B0]/20" data-id="element-270">
            <img src="https://cdn.magicpatterns.com/uploads/oFhxciA1DouMckY6MkQtEm/Hydra-Gloss-Lips.jpg" alt="Resultados reales de Hydra Gloss Lips - Procedimiento y resultados profesionales" className="w-full h-auto object-cover" data-id="element-271" />
          </div>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-10 border border-[#D4C4B0]/20" data-id="element-272">
          <div className="max-w-3xl mx-auto text-center mb-8 space-y-3" data-id="element-273">
            <h3 className="text-xl md:text-2xl font-semibold text-[#3D3028]" data-id="element-274">
              ¿Qué es el MASTER HYDRA GLOSS LIPS™ 2.0?
            </h3>
            <p className="text-sm md:text-base text-[#3D3028]/70 leading-relaxed" data-id="element-275">
              Es una formación digital profesional, con videos paso a paso +
              material descargable, diseñada para que no te falte nada a la hora
              de aprender, practicar y trabajar con clientas reales.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-276">
            {features.map((feature, index) => <div key={index} className="flex flex-col items-center text-center gap-3" data-id="element-277">
                <div className="bg-[#FAF8F4] p-3 rounded-xl text-[#3D3028]" data-id="element-278">
                  <feature.icon className="w-5 h-5" data-id="element-279" />
                </div>
                <span className="font-medium text-xs text-[#3D3028]/80" data-id="element-280">
                  {feature.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}